import { dateToString } from "utils/dateUtils";

export const keyNames = {
    fileNo: "File No",
    srcNo: "SRC No",
    alienRegistrationNo: "Alien Registration No",
    petitioner: "Petitioner",
    client_firstName: "First Name",
    client_lastName: "Last Name",
    client_middleName: "Middle Name",
    client_address: "Address",
    client_city: "City",
    client_homePhone: "Home Phone",
    client_birthDate: "Birth Date",
    client_email: "Email",
    client_ssn: "SSN",
};

export const valueNormalizers = {
    fileNo: (value) => value,
    srcNo: (value) => value,
    alienRegistrationNo: (value) => value,
    petitioner: (value) => value,
    client_firstName: (value) => value,
    client_lastName: (value) => value,
    client_middleName: (value) => value,
    client_address: (value) => value,
    client_city: (value) => value,
    client_homePhone: (value) => value,
    client_birthDate: (value) => (value && typeof value === "number" ? dateToString(new Date(value), false) : "Invalid date"),
    client_email: (value) => value,
    client_ssn: (value) => value,
};

const Immigration = {
    keyNames,
    valueNormalizers,
};

export default Immigration;
